@if (sessions) {
  <thead>
    <tr class="help-text">
      @if (sessions.length >= dashboardSessionsPerPage) {
        <th colspan="5" [translateParams]="{ count: dashboardSessionsPerPage }" translate>
          claims-list.component.first-items
        </th>
      }
    </tr>
    <tr>
      <th translate>session.learner</th>
      <th translate>session.website</th>
      <th translate>session.name</th>
      <th translate>session.wait</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @if (!sessions.length) {
      <tr class="nothing-yet">
        <td colspan="5" translate>claims-list.component.nothing-yet</td>
      </tr>
    }

    @for (session of sessions; track session.id) {
      <lv-claims-list-item
        ngForTrackBy="trackBy"
        [session]="session"
        [claimItemType]="claimItemType"
      ></lv-claims-list-item>
    }
  </tbody>
} @else {
  <thead>
    <tr class="help-text">
      <th colspan="5" class="loading" translate>claims-list.component.loading</th>
    </tr>
    <tr>
      <th translate>session.learner</th>
      <th translate>session.website</th>
      <th translate>session.name</th>
      <th translate>session.wait</th>
      <th></th>
    </tr>
  </thead>
  <tbody class="skeleton">
    <tr>
      <td colspan="5" translate>claims-list.component.loading</td>
    </tr>
  </tbody>
}
